/**
 * Convivium — Produttori JS
 * Product add-to-cart on producer detail page
 */
document.addEventListener('DOMContentLoaded', function () {

  /* -- La storia del produttore, accorciata --------------------------
     Il taglio lo fa il CSS a righe intere (.pr-hero__bio--corta). Qui si
     decide solo SE serve: si prova a tagliare, si guarda se e' rimasto
     fuori qualcosa, e se non e' rimasto fuori niente si toglie il taglio e
     il pulsante non compare nemmeno. Cosi' un produttore con quattro righe
     di storia non si ritrova un «leggi il resto» che non apre niente.

     Si rivaluta al ridimensionamento: girando il telefono cambia la
     larghezza, e con la larghezza cambia quanto testo sta in una riga. */
  (function () {
    var bio = document.querySelector('.pr-hero__bio');
    var btn = document.querySelector('.pr-hero__altro');
    if (!bio || !btn) return;

    var CHIUSO = 'Leggi il resto della nostra storia';
    var APERTO = 'Mostra meno';
    var aperto = false;

    function valuta() {
      if (aperto) return;                 // aperta per scelta: non la richiudo
      bio.classList.add('pr-hero__bio--corta');
      var nascosto = bio.scrollHeight - bio.clientHeight > 4;
      btn.hidden = !nascosto;
      if (!nascosto) bio.classList.remove('pr-hero__bio--corta');
    }

    btn.addEventListener('click', function () {
      aperto = !aperto;
      bio.classList.toggle('pr-hero__bio--corta', !aperto);
      btn.setAttribute('aria-expanded', String(aperto));
      btn.textContent = aperto ? APERTO : CHIUSO;
      if (!aperto) bio.scrollIntoView({ block: 'nearest' });
    });

    valuta();

    var attesa;
    window.addEventListener('resize', function () {
      clearTimeout(attesa);
      attesa = setTimeout(valuta, 150);
    });
  })();

  /* Il riquadro sta in cv-carrello.js, che il layout carica su ogni pagina.
     Prima ogni file aveva la sua copia di questa funzione: tre copie identiche
     che il giorno che se ne cambiava una sola cominciavano a divergere. */
  function showToast(msg, isError) {
    if (window.Convivium && window.Convivium.toast) window.Convivium.toast(msg, isError);
  }

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'produttore-page',
        data: {
          source: 'produttore-page',
          itemCount: cart ? cart.item_count : 0,
        },
      },
    }));
  }

  var grid = document.querySelector('.pr-products__grid');
  if (!grid) return;

  grid.addEventListener('click', async function (e) {
    var btn = e.target.closest('.pr-prod-card__add');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('pr-prod-card__add--loading');
    var origText = btn.textContent;
    btn.textContent = 'Aggiunta...';
    btn.disabled = true;

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });

      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || 'Errore');
      }

      var cartRes = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      var cart = cartRes.ok ? await cartRes.json() : null;
      dispatchCartUpdate(cart);
      showToast('Prodotto aggiunto al carrello');

    } catch (e) {
      showToast(e.message || 'Errore: riprova', true);
    } finally {
      btn.classList.remove('pr-prod-card__add--loading');
      btn.textContent = origText;
      btn.disabled = false;
    }
  });

});
